export const GET_CAMPAIGNS_LIST_REQUEST: any = 'GET_CAMPAIGNS_LIST_REQUEST'
export const GET_CAMPAIGNS_LIST_SUCCESS = 'GET_CAMPAIGNS_LIST_SUCCESS'
export const GET_CAMPAIGNS_LIST_FAILED = 'GET_CAMPAIGNS_LIST_FAILED'

export const ADD_NEW_CAMPAIGNS_REQUEST: any = 'ADD_NEW_CAMPAIGNS_REQUEST'
export const ADD_NEW_CAMPAIGNS_SUCCESS = 'ADD_NEW_CAMPAIGNS_SUCCESS'
export const ADD_NEW_CAMPAIGNS_FAILED = 'ADD_NEW_CAMPAIGNS_FAILED'
export const CLEAR_ADD_NEW_CAMPAIGNS_RESPONSE = 'CLEAR_ADD_NEW_CAMPAIGNS_RESPONSE'


export const GET_TAG_GENERATOR_REQUEST: any = 'GET_TAG_GENERATOR_REQUEST'
export const GET_TAG_GENERATOR_SUCCESS = 'GET_TAG_GENERATOR_SUCCESS'
export const GET_TAG_GENERATOR_FAILED = 'GET_TAG_GENERATOR_FAILED'

export const GET_EDIT_TAG_DATA_REQUEST: any = 'GET_EDIT_TAG_DATA_REQUEST'
export const GET_EDIT_TAG_DATA_SUCCESS = 'GET_EDIT_TAG_DATA_SUCCESS'
export const GET_EDIT_TAG_DATA_FAILED = 'GET_EDIT_TAG_DATA_FAILED'

export const UPDATE_EDIT_TAG_DATA_REQUEST: any = 'UPDATE_EDIT_TAG_DATA_REQUEST'
export const UPDATE_EDIT_TAG_DATA_SUCCESS = 'UPDATE_EDIT_TAG_DATA_SUCCESS'
export const UPDATE_EDIT_TAG_DATA_FAILED = 'UPDATE_EDIT_TAG_DATA_FAILED'

export const DELETE_TAG_CAMPAIGN_REQUEST = 'DELETE_TAG_CAMPAIGN_REQUEST'
export const DELETE_TAG_CAMPAIGN_SUCCESS = 'DELETE_TAG_CAMPAIGN_SUCCESS'
export const DELETE_TAG_CAMPAIGN_FAILED = 'DELETE_TAG_CAMPAIGN_FAILED'

export const GetCampaignsListAction = (filtersObjects: any) => {
    return {
        type: GET_CAMPAIGNS_LIST_REQUEST,
        filtering: filtersObjects
    }
}

export const GetTagGeneratorAction = (camp: String) => {
    return {
        type: GET_TAG_GENERATOR_REQUEST,
        campName: camp
    }
}

export const GetEditTagDataAction = (campName: String) => {
    return {
        type: GET_EDIT_TAG_DATA_REQUEST,
        campName: campName
    }
}

export const UpdateEditTagDataAction = (data: any, id: string) => {
    return {
        type: UPDATE_EDIT_TAG_DATA_REQUEST,
        editCampaign: data,
        campId: id
    }
}

export const AddNewCampaignAction = (data: any) => {
    return {
        type: ADD_NEW_CAMPAIGNS_REQUEST,
        newCampaign: data
    }
}

export const DeleteTagCampaign = (id:string)=>{
    return{
        type:DELETE_TAG_CAMPAIGN_REQUEST,
        id:id
    }
}

export const ClearAddNewCampaignResponse = () => {
    return {
        type: CLEAR_ADD_NEW_CAMPAIGNS_RESPONSE
    }
}

